import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as crypto from "crypto-js";
import { LoginRegisterService } from '../login-register.service';
import { ClarityService } from '../../services/clarity.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, OnChanges {

  @Input() isAdminExists: any;
  @Input() existingAdminEmail: any;
  @Output() loginSubmit: EventEmitter<any> = new EventEmitter();
  @Output() gotoRegisterTab: EventEmitter<any> = new EventEmitter();
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginRegisterService: LoginRegisterService,
    private clarityService: ClarityService
  ) {

  }

  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    rememberMe: [false], // Added rememberMe control
    rememberedEmail: [''] // Added rememberedEmail form control
  });

  ngOnInit() {
    // Track page view
    this.clarityService.trackPageView('login');

    this.loginRegisterService.currentUser.subscribe((res) => {
      if (res) {
        // Track successful login
        this.clarityService.trackLogin('admin', true);
        this.clarityService.setUserId(res.email || res._id);
        this.router.navigateByUrl('/dashboard/home');
      }
    });

    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      this.loginForm.patchValue({
        rememberedEmail: savedEmail,
        email: savedEmail,
        rememberMe: true // Set rememberMe to true if an email is saved
      });
    }

  }

  ngOnChanges() {
    const email = this.existingAdminEmail ? this.existingAdminEmail : ''
    this.loginForm.controls.email.setValue(email);
  }

  forgotPassword() {
    // Track forgot password action
    this.clarityService.trackUserAction('forgot_password_clicked');
    this.router.navigateByUrl('/login/forgot-password');
  }

  loginSumbit() {
    // Track login attempt
    this.clarityService.trackUserAction('login_attempt', {
      email: this.loginForm.value.email,
      hasRememberMe: this.loginForm.value.rememberMe
    });

    if (this.loginForm.value.rememberMe) {
      localStorage.setItem('rememberedEmail', this.loginForm.value.email);
    } else {
      localStorage.removeItem('rememberedEmail');
    }

    this.loginSubmit.emit({
      email: this.loginForm.value.email?.toLowerCase() ?? '',
      password: crypto.AES.encrypt(this.loginForm.value.password, "evaltrixSecret").toString()
    });
  }

  gotoRegister(): void {
    // Track register navigation
    this.clarityService.trackUserAction('register_navigation');
    // Clear sensitive form data when navigating away
    this.resetForm();
    this.gotoRegisterTab.emit();
  }

  // Public method so parent can clear when user switches tabs directly
  resetForm(): void {
    this.loginForm.reset({ rememberMe: false, rememberedEmail: '' });
  }

}
